import React, { createContext, useState, useEffect, useCallback } from 'react';

const pipelineContext = createContext();

const PipelineProvider = ({ children, isAuthenticated }) => {
	/**
	 * useContext: a way to share data between components without having to pass props manually at each level
	 * avoids 'prop drilling'
	 * ensures all components have access to the pipeline variables
	 */

	// 	capsInPipeline: list of captures in the users pipeline to be QC'd,
	// 	autoQCCaps: list of captures which are sent to Auto QC,
	// 	comm: smelters/stockpiles/aircraft,
	// 	qcType: daily/historic/upload only/Re QC,
	// 	qcPerc: % of caps in pipeline QC'd (based on newQC value),
	// 	progressBar: object with width & title property, to determine where user is in QC progress (type ie comm, qcType, Form, View Captures, Perform QC, Upload, Report),
	// 	qcInProgress: if user actively has captures assigned to them,
	// 	postQCPerformed: if post QC/ index calc has been successfully performed,
	// 	uploadPerformed: if upload has been successfully performed,
	// 	currentCaptureIndex: index of capsInPipeline of the current capture,
	// 	straightToQC: if user moves straight to QC from User Captures,
	// 	straightToUpload: if user moves straight to Upload ie qcType = Upload only,
	// 	loading: general variable to determine if anything is loading,
	// 	postQCData: when post QC/index calc has been successfully performed, the data delivered from the EP,
	// 	notificationsEnabled: boolean, if user wants to see toast notifications (toggled in sidebar),
	// 	onQCingPage: if user is on the QCing Page ie Perform QC,
	// 	onQCPage: if user is on the QC page ie the route for QC

	const initialState = {
		capsInPipeline: [],
		autoQCCaps: [],
		comm: undefined,
		qcType: undefined,
		qcPerc: 0,
		progressBar: {
			width: 0,
			title: ''
		},
		qcInProgress: false,
		postQCPerformed: false,
		uploadPerformed: false,
		currentCaptureIndex: 0,
		straightToQC: false,
		straightToUpload: false,
		loading: false,
		postQCData: null,
		notificationsEnabled: true,
		onQCingPage: false,
		onQCPage: false
	};

	const [capsInPipeline, setCapsInPipeline] = useState([]);
	const [autoQCCaps, setAutoQCCaps] = useState([]);
	const [comm, setComm] = useState();
	const [qcType, setQCType] = useState();
	const [qcPerc, setQCPerc] = useState(0);
	const [progressBar, setProgressBar] = useState({
		width: 0,
		title: ''
	});
	const [qcInProgress, setQCInProgress] = useState(false);
	const [onQCPage, setOnQCPage] = useState(false);
	const [postQCPerformed, setPostQCPerformed] = useState(false);
	const [uploadPerformed, setUploadPerformed] = useState(false);
	const [currentCaptureIndex, setCurrentCaptureIndex] = useState(0);
	const [straightToQC, setStraightToQC] = useState(false);
	const [straightToUpload, setStraightToUpload] = useState(false);
	const [loading, setLoading] = useState(false);
	const [navigateHome, setNavigateHome] = useState(false);
	const [postQCData, setPostQCData] = useState(null);
	const [notificationsEnabled, setNotificationsEnabled] = useState(true);
	const [onQCingPage, setOnQCingPage] = useState(false);

	const resetState = () => {
		//console.log('pipeline context resetting state');
		setCapsInPipeline(initialState.capsInPipeline);
		setAutoQCCaps(initialState.autoQCCaps);
		setComm(initialState.comm);
		setQCType(initialState.qcType);
		setQCPerc(initialState.qcPerc);
		setProgressBar(initialState.progressBar);
		setQCInProgress(initialState.qcInProgress);
		setPostQCPerformed(initialState.postQCPerformed);
		setUploadPerformed(initialState.uploadPerformed);
		setCurrentCaptureIndex(initialState.currentCaptureIndex);
		setStraightToQC(initialState.straightToQC);
		setStraightToUpload(initialState.straightToUpload);
		setLoading(initialState.loading);
		setPostQCData(initialState.postQCData);
		//setNotificationsEnabled(initialState.notificationsEnabled)
		//setNavigateHome(true)
	};

	return (
		<pipelineContext.Provider
			value={{
				capsInPipeline,
				setCapsInPipeline,
				autoQCCaps,
				setAutoQCCaps,
				comm,
				setComm,
				qcType,
				setQCType,
				qcPerc,
				setQCPerc,
				progressBar,
				setProgressBar,
				qcInProgress,
				setQCInProgress,
				onQCPage,
				setOnQCPage,
				postQCPerformed,
				setPostQCPerformed,
				uploadPerformed,
				setUploadPerformed,
				currentCaptureIndex,
				setCurrentCaptureIndex,
				straightToQC,
				setStraightToQC,
				straightToUpload,
				setStraightToUpload,
				navigateHome,
				setNavigateHome,
				resetState,
				loading,
				setLoading,
				postQCData,
				setPostQCData,
				notificationsEnabled,
				setNotificationsEnabled
			}}
		>
			{children}
		</pipelineContext.Provider>
	);
};

export { pipelineContext, PipelineProvider };
